// extracted by mini-css-extract-plugin
module.exports = {"container":"about-module--container--1ewHF","text":"about-module--text--jbgsJ","button":"about-module--button--11A-k","title":"about-module--title--1unRo"};